import { render, staticRenderFns } from "./PFormCheckBox.vue?vue&type=template&id=62dfbc8e&scoped=true&"
import script from "./PFormCheckBox.vue?vue&type=script&lang=ts&"
export * from "./PFormCheckBox.vue?vue&type=script&lang=ts&"
import style0 from "./PFormCheckBox.vue?vue&type=style&index=0&id=62dfbc8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dfbc8e",
  null
  
)

export default component.exports